import moment from "moment";
import swal from "sweetalert";

import commoncss from "../../../myfin_v2/css/common.module.css";
import buttoncss from "../../../myfin_v2/css/button.module.css";
import Modal from "../../../myfin_v2/elements/Modal";
import { Button } from "../../../myfin_v2/elements/Button";
import Dropdown from "../../../myfin_v2/elements/Dropdown";
import InputGroup from "../../../myfin_v2/elements/InputGroup";
import SuccessPopup from "../../../myfin_v2/elements/SuccessPopup";
import ErrorPopup from "../../../myfin_v2/elements/ErrorPopup";
import { ReactComponent as CloseIcon } from "../../../myfin_v2/assets/icons/close.svg";
import standaloneCss from "../../../myfin_v2/css/standalone.module.css";
import { useState, useEffect } from "react";
import { translateFSApiHandler, translateConsolApiHandler, fetchInvestmentRegisters } from "../ApiServices/apiHandler";
import {ReactComponent as CalendarIcon} from "../../../myfin_v2/assets/icons/Calendar.svg";

const TranslateFSModal = ({mode = "standalone", allProject=[], setShowTranslateFSModal }) => {
  const isStandalone = mode === "standalone";

  const functionalCurrencyList = ["INR", "USD", "LKR", "AUD", "CAD", "GBP", "EUR", "CHF"];

  // ── Standalone state ──────────────────────────────────────────────────
  const [allProjects, setAllProjects] = useState([]);
  const [projectId, setProjectId] = useState("");
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorData, setErrorData] = useState(null);

  // ── Consol state ──────────────────────────────────────────────────────
  const [consolID, setConsolID] = useState("");

  // ── Shared state ──────────────────────────────────────────────────────
  const [company, setCompany] = useState("");
  const [functionalCurrency, setFunctionalCurrency] = useState("");
  const [reportingCurrency, setReportingCurrency] = useState(null);
 // const [reportingCurrency, setReportingCurrency] = useState({ label: " ", value: " " });
  const [currentFinancialYear, setCurrentFinancialYear] = useState("");
  const [previousFinancialYear, setPreviousFinancialYear] = useState("");
  const [cyOpeningRate, setCYOpeningRate] = useState("");
  const [cyClosingRate, setCYClosingRate] = useState("");
  const [cyAverageRate, setCYAverageRate] = useState("");
  const [pyOpeningRate, setPYOpeningRate] = useState("");
  const [pyClosingRate, setPYClosingRate] = useState("");
  const [pyAverageRate, setPYAverageRate] = useState("");
  const [investmentRegister, setInvestmentRegister] = useState(null);
  const [fillCurrency, setFillCurrency] = useState(null);
  const [allInvestmentRegisters, setAllInvestmentRegisters] = useState([]);

  useEffect(() => {
    const getInvestmentRegisters = async () => {
      try {
        const res = await fetchInvestmentRegisters();
        if (res?.data?.success) {
          const formattedInvestments = res.data.investmentList.map((inv) => ({
            label: inv.name,
            value: inv._id
          }));
          setAllInvestmentRegisters(formattedInvestments);
        }
      } catch (error) {
        console.log("Error fetching investments", error);
      }
    };
    getInvestmentRegisters();
  }, []);
 
  // ── Standalone: build project list ───────────────────────────────────
  useEffect(() => {
    if (!isStandalone) return;
    const projectList = allProject.map((item) => ({
      label: item.project_name,
      value: item._id,
    }));
    setAllProjects(projectList);
  }, [allProject]);

  // ── Standalone: auto-fill on project select ───────────────────────────
  useEffect(() => {
    if (!isStandalone || !projectId) return;
    const project = allProject.find((p) => p._id === projectId);
    console.log("response:", project.currency); 
    const rateData = project?.translateFS;

    setCompany(project?.companyData);
    setFunctionalCurrency(project?.currency);
    setCurrentFinancialYear(
      project?.current_year ? moment(project.current_year).format("DD-MMM-YYYY") : ""
    );
    setPreviousFinancialYear(
      project?.previous_year ? moment(project.previous_year).format("DD-MMM-YYYY") : ""
    );

    if (project?.reportingCurrency) {
      setReportingCurrency({ label: project.reportingCurrency, value: project.reportingCurrency });
    } else {
      setReportingCurrency(null);
    }

    if (rateData) {
      setCYOpeningRate(rateData?.currentYearOpeningRate);
      setCYClosingRate(rateData?.currentYearClosingRate);
      setCYAverageRate(rateData?.currentYearAverageRate);
      setPYOpeningRate(rateData?.previousYearOpeningRate);
      setPYClosingRate(rateData?.previousYearClosingRate);
      setPYAverageRate(rateData?.previousYearAverageRate);
    } else {
      setCYOpeningRate("");
      setCYClosingRate("");
      setCYAverageRate("");
      setPYOpeningRate("");
      setPYClosingRate("");
      setPYAverageRate("");
    }
  }, [projectId]);

  // ── Consol: auto-fill on consol select ───────────────────────────────
  useEffect(() => {
    if (isStandalone || !consolID) return;
    const consol = allProject.find((c) => c._id === consolID);
    if (!consol) return;

    const rateData = consol?.translateFS;

    setCompany(consol?.parentCompanyData?.company_name || "");
    setFunctionalCurrency("");
    setCurrentFinancialYear(
      consol?.currentYear ? moment(consol.currentYear).format("DD-MMM-YYYY") : ""
    );
    setPreviousFinancialYear(
      consol?.previousYear ? moment(consol.previousYear).format("DD-MMM-YYYY") : ""
    );

    if (consol?.reportingCurrency) {
      setReportingCurrency({ label: consol.reportingCurrency, value: consol.reportingCurrency });
    } else {
      setReportingCurrency(null);
    }

    if (rateData) {
      setCYOpeningRate(rateData?.currentYearOpeningRate);
      setCYClosingRate(rateData?.currentYearClosingRate);
      setCYAverageRate(rateData?.currentYearAverageRate);
      setPYOpeningRate(rateData?.previousYearOpeningRate);
      setPYClosingRate(rateData?.previousYearClosingRate);
      setPYAverageRate(rateData?.previousYearAverageRate);

    } else {
      setCYOpeningRate("");
      setCYClosingRate("");
      setCYAverageRate("");
      setPYOpeningRate("");
      setPYClosingRate("");
      setPYAverageRate("");
    }
  }, [consolID]);

  // ── Save handler ──────────────────────────────────────────────────────
  const handleSaveAndTranslate = () => {
    if (!isStandalone) {
  const payload = {
    reportingCurrency: reportingCurrency?.value,
    // investmentID: investmentRegister?.value,
    translateFS: {
      currentYearOpeningRate: parseFloat(cyOpeningRate) || 0,
      currentYearClosingRate: parseFloat(cyClosingRate) || 0,
      currentYearAverageRate: parseFloat(cyAverageRate) || 0,
      previousYearOpeningRate: parseFloat(pyOpeningRate) || 0,
      previousYearClosingRate: parseFloat(pyClosingRate) || 0,
      previousYearAverageRate: parseFloat(pyAverageRate) || 0,
    },
  };

  translateConsolApiHandler({ consolID }, payload)
    .then((response) => {
      if (response?.data?.success === true) {
        setSuccessMessage("Data saved successfully.");
        setShowSuccessPopup(true);
      } else {
        setErrorData({
          title: "Error",
          message: response?.data?.error || "Unable to Save and Translate FS",
        });
      }
    })
    .catch((error) => {
      setErrorData({
        title: "Error",
        message: error?.response?.data?.error || "Unable to Save and Translate FS",
      });
    });
  return;
}

    const payload = {
      reportingCurrency: reportingCurrency?.value,
      investmentID: investmentRegister?.value,
      translateFS: {
        currentYearOpeningRate: cyOpeningRate,
        currentYearClosingRate: cyClosingRate,
        currentYearAverageRate: cyAverageRate,
        previousYearOpeningRate: pyOpeningRate,
        previousYearClosingRate: pyClosingRate,
        previousYearAverageRate: pyAverageRate,
      },
    };

    translateFSApiHandler({ projectID: projectId }, payload)
      .then((response) => {
        if (response?.data?.success === true) {
          setSuccessMessage("Data saved successfully.");
          setShowSuccessPopup(true);
        } else {
          setErrorData({
            title: "Error",
            message: response?.data?.error || "Unable to Save and Translate FS",
          });
        }
      })
      .catch((error) => {
        setErrorData({
          title: "Error",
          message: error?.response?.data?.error || "Unable to Save and Translate FS",
        });
      });
  };

  return (
    <>
      <ErrorPopup
        isOpen={errorData !== null}
        title={errorData?.title}
        message={errorData?.message}
        onClose={() => setErrorData(null)}
      />
      <SuccessPopup
        isOpen={showSuccessPopup}
        message={successMessage}
        onClose={() => {
          setShowSuccessPopup(false);
          setShowTranslateFSModal(false);
        }}
      />
      {!showSuccessPopup && (
      <Modal
        title={"Preset Information"}
        width="50%"
        headerActions={
          <CloseIcon onClick={() => setShowTranslateFSModal(false)} className="clickable" />
        }
        footerActions={
          <>
            <Button btnColor={buttoncss.secondary} onClick={() => setShowTranslateFSModal(false)} label="Cancel" />
            <Button btnColor={buttoncss.primary} label="Save and Translate" onClick={handleSaveAndTranslate} />
          </>
        }
        onClose={() => console.log("Modal Closed")}
      >
        <div style={{ padding: "0 10px", width: "100%", placeSelf: "center" }}>
          <InputGroup
            inputs={[
              <>
                <InputGroup
                  label={isStandalone ? "Select Financials" : "Select Consol FS"}
                  inputs={[
                    isStandalone ? (
                      <Dropdown
                        options={allProjects}
                        onSelect={(sel) => setProjectId(sel.value)}
                        placeHolder="Select Financials"
                        selected={allProjects.find((p) => p.value === projectId) || null}
                        searchable={true}
                      />
                    ) : (
                      <Dropdown
                        options={allProject.map((item) => ({
                          label: item.name,
                          value: item._id,
                        }))}
                        onSelect={(sel) => setConsolID(sel.value)}
                        placeHolder="Select Consol FS"
                        selected={allProject.map((item) => ({ label: item.name, value: item._id })).find((c) => c.value === consolID) || null}
                        searchable={true}
                      />
                    ),
                  ]}
                />
              </>,
              <>
                <InputGroup
                  label="Reporting Currency"
                  inputs={[
                    <Dropdown
                      options={functionalCurrencyList.map((item) => ({ label: item, value: item }))}
                      onSelect={(sel) => setReportingCurrency(sel)}
                      placeHolder="Select Currency"
                      selected={reportingCurrency}
                      searchable={true}
                    />,
                  ]}
                />
              </>,
            ]}
          />

          <div style={{ marginBottom: "10px" }}>
            <InputGroup
              inputs={[
                <>
                  <InputGroup
                    label="Company"
                    inputs={[
                      <input
                        type="text"
                        value={
                          isStandalone
                            ? company?.company_name ?? ""
                            : typeof company === "string"
                            ? company
                            : ""
                        }
                        placeholder="Company"
                        style={{ height: "38px" }}
                        disabled
                      />,
                    ]}
                  />
                </>,
                <>
                  <InputGroup
                    label="Functional Currency"
                    inputs={[
                      <input
                        type="text"
                        value={functionalCurrency || ""}
                        placeholder="Functional Currency"
                        style={{ height: "38px" }}
                        disabled
                      />,
                    ]}
                  />
                </>,
              ]}
            />
          </div>

          <InputGroup
            inputs={[
              <>
                <InputGroup
                  label="Current Financial Year"
                  inputs={[
                    <div className="input-with-icon">
                      <input
                        type="text"
                        value={currentFinancialYear}
                        placeholder="Current Financial Year"
                        style={{ height: "38px" }}
                        disabled
                      />
                      <span className="calendar-icon"><CalendarIcon /></span>
                    </div>,
                  ]}
                />
              </>,
              <>
                <InputGroup
                  label="Previous Financial Year"
                  inputs={[
                    <div className="input-with-icon">
                      <input
                        type="text"
                        value={previousFinancialYear}
                        placeholder="Previous Financial Year"
                        style={{ height: "38px" }}
                        disabled
                      />
                      <span className="calendar-icon"><CalendarIcon /></span>
                    </div>,
                  ]}
                />
              </>,
            ]}
          />

          {/* <hr /> */}

          {isStandalone && (
            <div style={{ marginTop: "10px" }}>
              <InputGroup
                label="Select Investment Register"
                inputs={[
                  <Dropdown
                    options={allInvestmentRegisters}
                    onSelect={(sel) => setInvestmentRegister(sel)}
                    placeHolder="Select Investment Register for accurate translation of equity balances"
                    selected={investmentRegister}
                    searchable={true}
                  />
                ]}
              />
            </div>
          )}

          <div style={{ marginTop : "20px" }}>
            <div className={commoncss.dFlexJustifysb}>
              <span>
                Translation information :{" "}
                {functionalCurrency && (
                  <span className={commoncss.label8}>
                    {functionalCurrency} to {reportingCurrency?.value || "_"}
                  </span>
                )}
              </span>
             </div>

            <div className={standaloneCss.translateCard}>
              <div className={standaloneCss.translateCardHeader} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span>Fill the details</span>
                {/* <div style={{ display: 'flex', gap: '10px' }}>
                  <Dropdown
                    options={functionalCurrencyList.map((item) => ({ label: item, value: item }))}
                    onSelect={(sel) => setFillCurrency(sel)}
                    placeHolder="Currency"
                    selected={fillCurrency}
                    searchable={true}
                  />
                  <Button btnColor={buttoncss.secondary} label="Confirm" onClick={() => {}} />
                </div> */}
              </div>
              <table className={standaloneCss.translateTable}>
                <thead>
                  <tr>
                    <th style={{ width: "25%", textAlign: "left", paddingLeft: "40px" }}>DATE</th>
                    <th style={{ width: "25%", textAlign: "center" }}>OPENING RATE</th>
                    <th style={{ width: "25%", textAlign: "center" }}>CLOSING RATE</th>
                    <th style={{ width: "25%", textAlign: "center" }}>AVERAGE RATE</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style={{ width: "25%", textAlign: "left", paddingLeft: "40px" }}><span>{currentFinancialYear}</span></td>
                    <td style={{ width: "25%" }}>
                      {(isStandalone ? currentFinancialYear : consolID) && (
                        <div style={{ display: "flex", justifyContent: "center" }}>
                          <InputGroup width="170px" input_width="170px" inputs={[
                            <input type="text" placeholder="CY Opening Rate" value={cyOpeningRate}
                              onChange={(e) => setCYOpeningRate(e.target.value)} />,
                          ]} />
                        </div>
                      )}
                    </td>
                    <td style={{ width: "25%" }}>
                      {(isStandalone ? currentFinancialYear : consolID) && (
                        <div style={{ display: "flex", justifyContent: "center" }}>
                          <InputGroup width="170px" input_width="170px" inputs={[
                            <input type="text" placeholder="CY Closing Rate" value={cyClosingRate}
                              onChange={(e) => setCYClosingRate(e.target.value)} />,
                          ]} />
                        </div>
                      )}
                    </td>
                    <td style={{ width: "25%" }}>
                      {(isStandalone ? currentFinancialYear : consolID) && (
                        <div style={{ display: "flex", justifyContent: "center" }}>
                          <InputGroup width="170px" input_width="170px" inputs={[
                            <input type="text" placeholder="CY Average Rate" value={cyAverageRate}
                              onChange={(e) => setCYAverageRate(e.target.value)} />,
                          ]} />
                        </div>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ width: "25%", textAlign: "left", paddingLeft: "40px" }}><span>{previousFinancialYear}</span></td>
                    <td style={{ width: "25%" }}>
                      {(isStandalone ? previousFinancialYear : consolID) && (
                        <div style={{ display: "flex", justifyContent: "center" }}>
                          <InputGroup width="170px" input_width="170px" inputs={[
                            <input type="text" placeholder="PY Opening Rate" value={pyOpeningRate}
                              onChange={(e) => setPYOpeningRate(e.target.value)} />,
                          ]} />
                        </div>
                      )}
                    </td>
                    <td style={{ width: "25%" }}>
                      {(isStandalone ? previousFinancialYear : consolID) && (
                        <div style={{ display: "flex", justifyContent: "center" }}>
                          <InputGroup width="170px" input_width="170px" inputs={[
                            <input type="text" placeholder="PY Closing Rate" value={pyClosingRate}
                              onChange={(e) => setPYClosingRate(e.target.value)} />,
                          ]} />
                        </div>
                      )}
                    </td>
                    <td style={{ width: "25%" }}>
                      {(isStandalone ? previousFinancialYear : consolID) && (
                        <div style={{ display: "flex", justifyContent: "center" }}>
                          <InputGroup width="170px" input_width="170px" inputs={[
                            <input type="text" placeholder="PY Average Rate" value={pyAverageRate}
                              onChange={(e) => setPYAverageRate(e.target.value)} />,
                          ]} />
                        </div>
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </Modal>
      )}
    </>
  );
};

export default TranslateFSModal;